//import Section from '../components/Section/Section';

import styles from './Ticket.module.css';

import Dropdown from 'react-dropdown'
import DragAndDrop from '../DragNDrop';
//import { Hint } from 'react-autocomplete-hint';
import Draggable from 'react-draggable';
import moment from 'moment';

import ReactChipInput from '../components/react-chip-input/index';
import JobImages from '../OneJobPage/JobImages';

const TicketInfo = (props) => {

    const {
        active,
        ticket,
        //jobNumber,
        //pole,
        changePermitType,
        //specHintData,
        //setSpecText,
        //specText,
        handleAmbMeetup,
        handleEhasp,
        changeRadio,
        handleDigDrop,
        handleNRADrop,
        handlePermitDrop,
        loadingPermitDnD,
        loadingDigSafeDnD,
        loadingNRADnD,
        addPermit,
        updateWorkingNote,
        handleDeleteWoChip,
        handleAddWoChip,
        addNote,
        toggleAddNote,
        activeWorkingNote,
        digsafe,
        nra,
        permit_0,
        workingForemenForDropdown,
        //handleFileSelectClick,
        handleDigFileSelectClick,
        handlePermitFileSelectClick,
        handleNraFileSelectClick,
        handleDigSafeFileUpload,
        handleNRAFileUpload,
        handlePermitFileUpload,
        removeFile,
        handleWorkingForemanChange,
        handleImageDeleted: onImageDeleted
    } = props;
    
    //console.log('TicketInfo received ticket:', ticket);
    //console.log('TicketInfo images:', ticket?.images);

    const handleLocalImageDeleted = (updatedImages) => {
        if (ticket && ticket.images) {
            // If updatedImages is an array, it's a new image being added
            // If updatedImages is a number, it's an image ID being deleted
            if (Array.isArray(updatedImages)) {
                onImageDeleted(updatedImages);
            } else {
                const updatedImagesList = ticket.images.filter(img => img.id !== updatedImages);
                onImageDeleted(updatedImagesList);
            }
        }
    };

    return (
        <div className={`tab-pane fade${active ? ' show active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">  
          
          {/* section - Work Order / Blueprint */}
          <div className="row flex-column flex-sm-row section workOrderBlueprint">
            {/* item - Assign to */}
            <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item workOrderNum`}>
              <label className="labelTitle lg">Assigned to: </label>
              <div className="dropdown">
                  <Dropdown
                    options={workingForemenForDropdown ? workingForemenForDropdown : []}
                    onChange={handleWorkingForemanChange}
                    value={ticket ? ticket.assigned_to_name : ''}
                    />
                </div>
              {/* <input
                  type="text"
                  readOnly
                  value={ticket ? ticket.assigned_to_name : ''} 
                  placeholder="Not assigned yet (Use iPad app to assign)"
                  /> */}
            </div>
            {/* item - Work Order Number */}
            <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item workOrderNum`}>
              <label className="labelTitle lg">Work Order Number</label>
              {<ReactChipInput
                chips={ticket && ticket.work_orders ? ticket.work_orders : []}
                onSubmit={(chip) => handleAddWoChip(chip)}
                onRemove={(chip, index) => handleDeleteWoChip(chip, index)}
                /> 
                }
            </div>

         {/* item - EHASP */}
         <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item ehasp">
                <label
                  className="labelTitle lg"
                  htmlFor="ehasp"
                >
                  EHASP
                </label>
                <input
                  type="text"
                  name="ehasp"
                  id="ehasp"
                  defaultValue={ticket && ticket.ehasp  ? ticket.ehasp : ''}
                  onChange={handleEhasp} />
             
            
          </div>


            {/* item - Ambulance Meetup */}
              <div className="col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item ambulanceMeetup">
                <label
                  className="labelTitle lg"
                  htmlFor="ambMeetup"
                >
                  Ambulance Meetup
                </label>
                <input
                  type="text"
                  name="ambMeetup"
                  id="ambMeetup"
                  defaultValue={ticket && ticket.ambulance_meetup  ? ticket.ambulance_meetup : ''}
                  onChange={handleAmbMeetup} />
              </div>
            
          </div>

          {/* section - Digsafe / NRA / DNR */}
          <div className="row flex-column flex-sm-row section sectionDigsafe">
                
            {/* item - Digsafe */}
            <div className={`col-12 d-flex flex-column flex-sm-row flex-wrap align-items-sm-center justify-content-between item digSafe ${styles.itemDigsafe}`}>
              <label className="col-sm-6 pr-0 pl-0 labelTitle lg">Digsafe</label>
              <div className="col-sm-3 px-0 pb-4">
                <div className="d-flex flex-column flex-sm-row radioItems">
                  <input className="" type="radio" name="flexRadioDigsafe" id="flexRadioDefaultDig1" checked={ticket && ticket.dig_safe_required === 1  ? true : false} onChange={(e) => changeRadio("dig", true, e)} />
                  <label className="form-check-label" htmlFor="flexRadioDefaultDig1">Yes</label>
                  <input className="" type="radio" name="flexRadioDigsafe" id="flexRadioDefaultDig2" checked={ticket && ticket.dig_safe_required === 1  ? false : true} onChange={(e) => changeRadio("dig", false, e)}/>
                  <label className="form-check-label" htmlFor="flexRadioDefaultDig2">No</label>
                </div>
              </div>
              <div className={`col-sm-6 offset-6 px-0 upload-section ${styles.uploadSection}`}>
                <div style={{position: 'absolute', top: '0', left: '0', width:'100%', height: '100%', display: loadingDigSafeDnD ? 'block' : 'none', textAlign: 'center', paddingTop: '5px'}}>
                  
                  <div style={{zIndex: '2', position: 'relative'}}>
                    <svg style={{animationName: 'spin', animationDuration: '1000ms', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }} width="50" height="50" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                  </div>
                  <div style={{background: 'black', opacity: '.2', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1'}}></div>
                </div>  
                <div style={{display: 'none'}}>
                    <input type="file" ref={digsafe} onChange={handleDigSafeFileUpload}/>
                </div>
                
                <DragAndDrop
                  handleDrop={handleDigDrop}
                  handleFileSelect={handleDigFileSelectClick}
                  file={ticket && ticket.dig_safe_url ?  {name:(ticket.dig_safe_name?ticket.dig_safe_name:"Digsafe"), url:ticket.dig_safe_url} : {}}
                  removeFiles={removeFile}
                  type={'dig_safe'} 
                />
                
              </div>
            </div>

            {/* item - NRA */}
            <div className={`col-12 d-flex flex-column flex-sm-row flex-wrap align-items-sm-center justify-content-between item nra`}>
              <label className="col-sm-6 pr-0 pl-0 labelTitle lg">NRA</label>
              <div className="col-sm-6 px-0 pb-4">
                <div className="d-flex flex-column flex-sm-row radioItems">
                  <input className="" type="radio" name="flexRadioNRA" id="flexRadioDefaultNRA1" checked={ticket && ticket.nra_required === 1 ? true  : false} onChange={(e) => changeRadio("nra", true, e)}/>
                  <label className="form-check-label" htmlFor="flexRadioDefaultNRA1">Yes</label>
                  <input className="" type="radio" name="flexRadioNRA" id="flexRadioDefaultNRA2" checked={ticket && ticket.nra_required === 1 ? false  : true} onChange={(e) => changeRadio("nra", false, e)}/>
                  <label className="form-check-label" htmlFor="flexRadioDefaultNRA2">No</label>
                </div>
              </div>
              <div className="col-sm-6 offset-6 px-0 upload-section">
                <div style={{position: 'absolute', top: '0', left: '0', width:'100%', height: '100%', display: loadingNRADnD ? 'block' : 'none', textAlign: 'center', paddingTop: '5px'}}>
                  
                  <div style={{zIndex: '2', position: 'relative'}}>
                    <svg style={{animationName: 'spin', animationDuration: '1000ms', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }} width="50" height="50" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                  </div>
                  <div style={{background: 'black', opacity: '.2', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1'}}></div>
                </div>
                <div style={{display: 'none'}}>
                    <input type="file" ref={nra} onChange={handleNRAFileUpload}/>
                </div>
                <DragAndDrop
                  handleDrop={handleNRADrop}
                  handleFileSelect={handleNraFileSelectClick}
                  file={ticket && ticket.nra_url ? {name:(ticket.nra_name?ticket.nra_name : "Nra"), url:ticket.nra_url} : {}}
                  removeFiles={removeFile}
                  type={'nra'} />
                  
              </div>
            </div>

            {/* section - Images */}
            {ticket && (
                <div className="row flex-column flex-sm-row section sectionImages">
                    <div className="col-12">
                        <label className="labelTitle lg">Photos</label>
                        <JobImages 
                            images={ticket.images || []} 
                            onImageDeleted={handleLocalImageDeleted}
                            ticketId={ticket.id}
                            poleName={ticket.pole_name || (ticket.pole && ticket.pole.pole_name) || ''}
                            lineName={ticket.line_name || (ticket.pole && ticket.pole.line_name) || ''}
                        />
                    </div>
                </div>
            )}

          </div>
          
          {/* section - Permit Type */}
          <div className="row flex-column flex-sm-row section sectionDigsafe">
                

                {/* FIX this was just a copy paste from dig drop */}
            {/* item - Permit Type */}
            {  
            ticket && ticket.permits && ticket.permits.map((permit, index) => {
              
            return <div className={`col-12 d-flex flex-column flex-sm-row align-items-sm-center justify-content-between item permitType`} key={index}>
              <div className="col-sm-4 pr-0 pl-0 pb-4">
                
                <label className="labelTitle">Permit Type</label>
                <input 
                  value={permit.permit_type}
                  onChange={(e) => changePermitType(e.target.value, index)}
                />
              </div>
              <div className="col-sm-6 px-0 upload-section">
                <div style={{position: 'absolute', top: '0', left: '0', width:'100%', height: '100%', display: loadingPermitDnD[index] ? 'block' : 'none', textAlign: 'center', paddingTop: '5px'}}>
                  
                  <div style={{zIndex: '2', position: 'relative'}}>
                    <svg style={{animationName: 'spin', animationDuration: '1000ms', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }} width="50" height="50" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg" ><path fillRule="evenodd" clipRule="evenodd" d="M117.236 117.564L135.488 51.7447C92.1144 58.0338 57.8376 92.408 51.6958 135.829L27.8827 142.432C31.5571 80.9652 80.6763 31.7417 142.099 27.9031L149.836 0L149.836 27.6621V50.7138L149.836 149.836L150 150L182.436 117.564L247.963 135.734C241.785 92.3581 207.526 58.0292 164.185 51.7447L157.574 27.9031C218.965 31.7398 268.066 80.9159 271.784 142.34L300 150.164L150.164 150.164L182.436 182.436L164.279 247.914C207.349 241.626 241.429 207.643 247.863 164.621L271.742 158C267.712 219.081 218.792 267.897 157.666 271.763L149.836 300L149.836 272.01V248.959L149.836 150.491L117.564 182.764L51.7948 164.526C58.1928 207.593 92.292 241.622 135.393 247.914L142.006 271.763C80.8492 267.895 31.9107 219.032 27.9244 157.907L0 150.164L27.6625 150.164H50.7143L149.836 150.164L117.236 117.564Z" fill="#FFCC18"></path></svg>
                  </div>
                  <div style={{background: 'black', opacity: '.2', width: '100%', height: '100%', position: 'absolute', top: '0', left: '0', zIndex: '1'}}></div>
                </div>
                <div style={{display: 'none'}} data-index={{index}}>
                    <input type="file" ref={permit_0} onChange={(e) => handlePermitFileUpload(index, e) }/>
                </div>
                <DragAndDrop
                  handleDrop={handlePermitDrop}
                  index={index}
                  handleFileSelect={handlePermitFileSelectClick}
                  file={permit.permit_url ? {name:(permit.permit_name?permit.permit_name: ""), url:permit.permit_url} : {}}
                  removeFiles={removeFile}
                  type={'permit'}
                   />
              </div>
            </div>
            
            })
          }
              {/* END FIX */}

            {/* item - Add Another Permit btn */}
            <div className={`col-sm-6 offset-sm-6 d-flex flex-row justify-content-end btn-action text-right item addNewPermit`}>
              <button type="button" className="btn btn-primary text-center" onClick={addPermit}>
                <div className="d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" strokeWidth="2" stroke="#fff">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                  </svg>
                  <span>{(ticket && ticket.permits && ticket.permits.length > 0) ? "Add Another Document" : "Add a Document"}</span>
                </div>
              </button>
            </div>
          </div>

          {/* section - Notes */}
          <div className="row flex-row section sectionNotes">

            {/* item - Notes */}
            
            <div className={`col-12 d-flex flex-column item notes`}>
              <label className="label labelTitle" htmlFor="exampleFormControlTextarea1">Notes</label>
              {
                  ticket && ticket.notes && ticket.notes.map((note, idx) => {
                      return <div key={idx}>
                                  <br/>
                                  <b>{note.author} </b> {note.id ? "on" : ""} {moment(note.created_date).isValid() ? moment(note.created_date).format("MMM DD YY h:mm:ss A") : note.created_date}
                                    <p >{note.note_text}</p>
                                  </div>

                  })

              }
              {/* <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" className="w-100" value={notesAsString}  readOnly /> */}
            </div>
            <div className={`col-sm-6 offset-sm-6 d-flex flex-row justify-content-end btn-action text-right item addNewPermit`}>
              <button type="button" className="btn btn-primary text-center" onClick={toggleAddNote}>
                <div className="d-flex align-items-center justify-content-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" strokeWidth="2" stroke="#fff">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                  </svg>
                  <span>{(ticket && ticket.notes && ticket.notes.length > 0) ? "Add Another Note" : "Add a note" }</span>
                </div>
              </button>
            </div>
          </div>


          {
          activeWorkingNote &&
            <Draggable>
              <div className={`container-fluid modal display-block show col-4 ${styles.notesModal}`} style={{margin:"auto"}}>

                <div className={styles.notesFrame}>
                  <div className={`row flex-row section sectionNotes ${styles.notesSectionNotes}`}>

                    <div className={`col-12 ${styles.notesHeader}`}>
                      <h5 className={styles.title}>Notes</h5>

                      <button type="button" className={`close modalHeaderClose ${styles.notesCLose}`} onClick={toggleAddNote}><span aria-hidden="true">×</span></button>
                    </div>

                    <div className={`col-12 d-flex flex-column notes ${styles.notesBody}`}>
                      <label className="label labelTitle" htmlFor="exampleFormControlTextarea1">Notes</label>
                      <textarea className="form-control w-100" id="exampleFormControlTextarea1" rows="3" value={activeWorkingNote ? updateWorkingNote.note : ''} onChange={(e) => updateWorkingNote(e)}></textarea>
                    </div>

                    <div className={`col-12 d-flex flex-row justify-content-end btn-action addNewPermit ${styles.notesFooter}`}>
                      <button type="button" className="btn btn-t text-center" onClick={toggleAddNote}>
                        <span>Close</span>
                      </button>
                      <button type="button" className="btn btn-primary text-center" onClick={addNote}>
                        <span>Submit</span>
                      </button>
                    </div>
              
                  </div>
                </div>

              </div>
            </Draggable>
          }




        
        </div>
    )
}

export default TicketInfo